/// <reference path="../../typings/browser.d.ts" />

namespace Application.Common {
    'use strict';

    /**
     * Theme class
     */

    const DARK_THEME_URL: string = 'plugins/altair/assets/css/dark-theme.css';

    export class Theme {
        private static darkThemeElement: HTMLLinkElement = undefined;

        public static setDefaultTheme(): void {
            if (this.darkThemeElement !== undefined) {
                this.darkThemeElement.remove();
                this.darkThemeElement = undefined;
            }
        }

        public static setDarkTheme(): void {
            if (this.darkThemeElement === undefined) {
                let element: HTMLLinkElement = this.darkThemeElement = document.createElement("link");
                element.rel = "stylesheet";
                element.type = "text/css";
                element.href = DARK_THEME_URL;
                document.head.appendChild(element);
            }
        }
    }
}